import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { CandidateBulkActionsEffects } from './store/bulk-actions/bulk-actions.effects';
import {
  CandidateBulkNamespace,
  CandidateBulkReducer,
} from './store/bulk-actions/bulk-actions.store';
import { CandidateAutoUpdateEffects } from './store/candidate-auto-update.effects';
import { CandidateEffects } from './store/candidate/candidate.effects';
import { candidateNamespace, CandidateReducer } from './store/candidate/candidate.store';
import { CandidateCountersEffects } from './store/counters/candidate-counters.effects';
import {
  CandidateCountersNamespace,
  CandidateCountersReducer,
} from './store/counters/candidate-counters.store';
import { FullCandidateEffects } from './store/full-candidate/full-candidate.effects';
import {
  FullCandidateNamespace,
  FullCandidateReducer,
} from './store/full-candidate/full-candidate.store';

@NgModule({
  imports: [
    StoreModule.forFeature(candidateNamespace, CandidateReducer),
    StoreModule.forFeature(CandidateBulkNamespace, CandidateBulkReducer),
    StoreModule.forFeature(FullCandidateNamespace, FullCandidateReducer),
    StoreModule.forFeature(CandidateCountersNamespace, CandidateCountersReducer),
    EffectsModule.forFeature([
      CandidateEffects,
      CandidateBulkActionsEffects,
      FullCandidateEffects,
      CandidateCountersEffects,
      CandidateAutoUpdateEffects,
    ]),
  ],
})
export class CandidateDataModule {}
